export const MANAGE_RIDES_ALL_START = "MANAGE_RIDES_ALL_START";
export const MANAGE_RIDES_ALL_ERROR = "MANAGE_RIDES_ALL_ERROR";
export const MANAGE_RIDES_ALL_SUCCESS = "MANAGE_RIDES_ALL_SUCCESS"
export const MANAGE_RIDES_ON_TOUR_SUCCESS="MANAGE_RIDES_ON_TOUR_SUCCESS";
export const MANAGE_RIDES_ASSIGNED_SUCCESS = "MANAGE_RIDES_ASSIGNED_SUCCESS"
export const MANAGE_RIDES_MAINTENANCE_SUCCESS = "MANAGE_RIDES_MAINTENANCE_SUCCESS"
export const MANAGE_RIDES_AVAILABLE_SUCCESS="MANAGE_RIDES_AVAILABLE_SUCCESS"

export const GET_PENDING_VERIFICATION_RIDES_START = "GET_PENDING_VERIFICATION_RIDES_START";
export const GET_PENDING_VERIFICATION_RIDES_ERROR = "GET_PENDING_VERIFICATION_RIDES_ERROR";
export const GET_PENDING_VERIFICATION_RIDES_SUCCESS = "GET_PENDING_VERIFICATION_RIDES_SUCCESS"

export const GET_BULK_UPLOAD_LIST_START = "GET_BULK_UPLOAD_LIST_START";
export const GET_BULK_UPLOAD_LIST_ERROR = "GET_BULK_UPLOAD_LIST_ERROR";
export const GET_BULK_UPLOAD_LIST_SUCCESS = "GET_BULK_UPLOAD_LIST_SUCCESS"

export const ADD_MOTORCYCLE_SUCCESS = "ADD_MOTORCYCLE_SUCCESS";
export const ADD_MOTORCYCLE_ERROR = "ADD_MOTORCYCLE_ERROR";
export const ADD_MOTORCYCLE_START = "ADD_MOTORCYCLE_START";

export const GET_MOTORCYCLE_BY_ID_SUCCESS = "GET_MOTORCYCLE_BY_ID_SUCCESS";
export const GET_MOTORCYCLE_BY_ID_ERROR = "GET_MOTORCYCLE_BY_ID_ERROR";
export const GET_MOTORCYCLE_BY_ID_START = "GET_MOTORCYCLE_BY_ID_START";

export const GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS =
  "GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS";
export const GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR =
  "GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR";
export const GET_REGISTARATION_DETAILS_FROM_CHASIS_START =
  "GET_REGISTARATION_DETAILS_FROM_CHASIS_START";

export const STATE_LIST_SUCCESS = "STATE_LIST_SUCCESS";
export const STATE_LIST_ERROR = "STATE_LIST_ERROR";

export const UPLOAD_BULK_MOTORCYCLE_SUCCESS = "UPLOAD_BULK_MOTORCYCLE_SUCCESS";
export const UPLOAD_BULK_MOTORCYCLE_ERROR = "UPLOAD_BULK_MOTORCYCLE_ERROR";
export const UPLOAD_BULK_MOTORCYCLE_START = "UPLOAD_BULK_MOTORCYCLE_START";

export const QUICK_EDIT_MOTORCYCLE_START = "QUICK_EDIT_MOTORCYCLE_START";
export const QUICK_EDIT_MOTORCYCLE_SUCCESS = "QUICK_EDIT_MOTORCYCLE_SUCCESS";
export const QUICK_EDIT_MOTORCYCLE_ERROR = "QUICK_EDIT_MOTORCYCLE_ERROR";

export const GET_MOTORCYCLE_FAMILY_START = "GET_MOTORCYCLE_FAMILY_START";
export const GET_MOTORCYCLE_FAMILY_SUCCESS = "GET_MOTORCYCLE_FAMILY_SUCCESS";
export const GET_MOTORCYCLE_FAMILY_ERROR = "GET_MOTORCYCLE_FAMILY_ERROR";